import Framework, { BaseService } from '@greenville/framework';
import _ from 'lodash';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ChatgptUtilityService extends BaseService {
  constructor() {
    super(constants.GET_CHATGPT_DATA, 'chatgptUtilityStatus');
  }

  handleEvent(eventName, event) {
    const headers = {
      [constants.BERLIN_TENANT_ID_HEADER]: event.payload.tenantId
    };
    let payload = {};
    payload = _.omit(event.payload, ['tenantId']);
    return this.getClient('evergreen').post(`/chat/table`, payload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      const notification = {
        open: true,
        type: 'success',
        message: 'Data Fetched successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('chatgptUtility').setResponse(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const bookStatus = Framework.getStoreRegistry().getStore('chatgptUtility').getAllBookStatus();
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error && !bookStatus) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('chatgptUtility').resetStoreValues();
  }
}
